import React from 'react';
import { ToastsContainer } from '@periodica/ui-kit';
import { UseDeskProvider } from '@periodica/usedesk';
import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { SelectedCityProvider } from './src/components/DeliveryWidget';
import { AlertProvider } from './src/hooks/useAlertContext';

const queryClient = new QueryClient();

export default function ({ element }) {
  return (
    <QueryClientProvider client={queryClient}>
      <UseDeskProvider>
        <SelectedCityProvider>
          <AlertProvider>
            {element}
            <ToastsContainer />
          </AlertProvider>
        </SelectedCityProvider>
      </UseDeskProvider>
    </QueryClientProvider>
  );
}
